// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitles_subtitles__5GFlm {
  pointer-events: none;

  position: absolute;
  bottom: 24px;

  align-self: center;

  margin: 0 16px;
  padding: 0.4em 1em;

  font-family: var(--subtitleFontFamily) !important;
  font-size: var(--subtitleFontSize) rem;
  font-size: calc(max(0.75rem, min(calc(var(--wrapperWidth) / 50 * 0.0625rem), 1.5rem)) * var(--subtitleFontSize));
  font-feature-settings: ;
  font-variant: var(--subtitleFontVariant);
  color: var(--subtitleFontColor);
  text-align: center;

  background: var(--subtitleBackgroundColor); /* backwards compatible */

  transition: bottom 0.2s;
}

@supports (color: color-mix(in lch, red, blue)) {
.subtitles_subtitles__5GFlm {
  background: color-mix(in srgb, var(--subtitleBackgroundColor), transparent var(--subtitleBackgroundTransparency));
}
}

.subtitles_withSpaceForBottomBar__LOUq7 {
  bottom: 100px;
  bottom: max(90px, min(25%, 120px));
}
`, "",{"version":3,"sources":["webpack://./src/components/subtitles/subtitles.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,YAAY;;EAEZ,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;;EAElB,iDAAiD;EACjD,sCAAsC;EACtC,gHAA6G;EAC7G,uBAAwC;EAAxC,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;;EAElB,0CAA0C,EAAE,yBAAyB;;EAGrE,uBAAuB;AACzB;;AAtBA;AAAA;EAmBE,iHAAiH;AAGnH;AAAA;;AAEA;EACE,aAAa;EACb,kCAA+B;AACjC","sourcesContent":[".subtitles {\n  pointer-events: none;\n\n  position: absolute;\n  bottom: 24px;\n\n  align-self: center;\n\n  margin: 0 16px;\n  padding: 0.4em 1em;\n\n  font-family: var(--subtitleFontFamily) !important;\n  font-size: var(--subtitleFontSize) rem;\n  font-size: calc(clamp(0.75rem, calc(var(--wrapperWidth) / 50 * 0.0625rem), 1.5rem) * var(--subtitleFontSize));\n  font-variant: var(--subtitleFontVariant);\n  color: var(--subtitleFontColor);\n  text-align: center;\n\n  background: var(--subtitleBackgroundColor); /* backwards compatible */\n  background: color-mix(in srgb, var(--subtitleBackgroundColor), transparent var(--subtitleBackgroundTransparency));\n\n  transition: bottom 0.2s;\n}\n\n.withSpaceForBottomBar {\n  bottom: 100px;\n  bottom: clamp(90px, 25%, 120px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitles": `subtitles_subtitles__5GFlm`,
	"withSpaceForBottomBar": `subtitles_withSpaceForBottomBar__LOUq7`
};
export default ___CSS_LOADER_EXPORT___;
